import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default class SearchVlmCalendars extends Component {

constructor(props)
{
	//console.log('userProfile = '+JSON.stringify(props.currentUserProfile));
	console.log('userId = '+JSON.stringify(props.userId));
	console.log('authToken = '+JSON.stringify(props.authToken));
	super(props);
}

state =
{
		calendarsObject: {},
		calendars: []
};

componentDidMount()
{
	console.log('userprofile id => ' + this.props.userId);
	this.handleOnLoad();
}

handleOnLoad = () => {
  axios.get(`${global.config.apiServicesUrl}/vlm-calendars?filter[where][createUser][eq]=${this.props.userId}`).then(res => {
  const calendars = res.data;
  console.log(calendars);
  this.setState({ calendars : res.data });
	});
}


render(){

return (


				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<a href="index.html" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</a>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<a href="index.html" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</a>
									</li>
								</ul>
							</div>
							<a class="btn btn-primary" href="calendar-view">Calendar View</a>&nbsp;
							<a class="btn btn-success" href="create-calendar">Create Calendar Event</a>&nbsp;
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="index.html" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
						<div class="m-portlet">
							<div class="row">
								<h3 class="col-sm-2 m-widget1__title">
									Calendar Events
								</h3>
								<div class="col m--align-center">
									<input class="form-control input-xlarge col-sm-8" placeholder="Filter" />
								</div>
							</div>
	
	
	<table class="oux_table table table-striped table-bordered table-hover" id="list" border="1" var="item" rows="20"  value="#{ombCustomerForm.searchResults }">

			<thead>
				<tr>
					<th scope = "col">Id</th>
					<th scope = "col">Name</th>
					{/*
					<th scope = "col">Status</th>
					*/}
					<th scope = "col">Date</th>
					<th scope = "col">Description</th>
					<th scope = "col">Actions</th>
				</tr>
			</thead>

			<tbody>

				{this.state.calendars.map( ( {calendarId, calendarName, calendarStatusCode, calendarEntryDate, calendarDescr} ) => {

					return	<tr>

							
							<td><Link  to={{ pathname: "/manage-calendar", search : `?id=${calendarId}` }}>{calendarId}</Link></td>
							<td><Link  to={{ pathname: "/manage-calendar", search : `?id=${calendarId}` }}>{calendarName}</Link></td>
							{/*
							<td><Link  to={{ pathname: "/manage-calendar", search : `?id=${calendarId}` }}>{calendarStatusCode}</Link></td>
							*/}
							<td><Link  to={{ pathname: "/manage-calendar", search : `?id=${calendarId}` }}>{String(calendarEntryDate).substring(0,16).replace('T', ' ')}</Link></td>
							<td><Link  to={{ pathname: "/manage-calendar", search : `?id=${calendarId}` }}>{calendarDescr }</Link></td>
							<td>

										<button class="btn btn-danger btn-sm">Delete</button>
							</td>
						</tr>


				})
			}

			</tbody>


		</table>
					</div>
						</div>		
					</div>
	            	</div>	
            </div>
            
			</div>

);
}
}

